/**
 * Medbook
 * Medbook api
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ProcedureAirwaysInner { 
    /**
     * 
     */
    id: number;
    /**
     * 
     */
    label: string;
    /**
     * 
     */
    option?: ProcedureAirwaysInner.OptionEnum;
}
export namespace ProcedureAirwaysInner {
    export type OptionEnum = 'success';
    export const OptionEnum = {
        Success: 'success' as OptionEnum
    };
}


